let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7bHKQ")).then(() => parcelRequire('8B3dR'));